import isEmpty from "lodash/isEmpty";
import find from "lodash/find";

import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";
import MessageType from "../../constants/ChatMessageTypes";
import QuestionStore from "./QuestionStore";
import ResponseStore from "./ResponseStore";
import ActionBarHelper from "../../utils/chat/ActionBarHelper";

class ConfirmationMessageStore {
    constructor() {
        this.bindActions(ChatActions);
        this.bindListeners({
            onPerformingAction: [
                ChatActions.autoResponseReply,
                ChatActions.responseAccept,
                ChatActions.reviewMarkAsResolved,
            ],
            onPerformingActionFail: [
                ChatActions.autoResponseReplyFail,
                ChatActions.responseAcceptFail,
                ChatActions.reviewMarkAsResolvedFail,
            ],
            onPerformingActionSuccess: [
                ChatActions.autoResponseReplySuccess,
                ChatActions.responseAcceptSuccess,
                ChatActions.reviewMarkAsResolvedSuccess,
            ],
        });

        this.state = {
            buttons: [],
            isLoading: false,
            messageType: undefined,
        };
    }

    onCreateActionBar({ buttons, messageType }) {
        this.setState({
            buttons,
            messageType,
        });
    }

    onClearActionBar() {
        this.setState({
            buttons: [],
            isLoading: false,
            messageType: undefined,
        });
    }

    onPerformingAction() {
        this.setState({ isLoading: true });
    }

    onPerformingActionFail() {
        this.setState({ isLoading: false });
    }

    onPerformingActionSuccess() {
        this.onClearActionBar();
    }

    onLoadSuccess() {
        this.waitFor(ResponseStore);
        this.waitFor(QuestionStore);

        const answerCount = ResponseStore.getAnswerCountForResponses();
        const messageType = this.getInstance().getMessageType();
        const questionIsClosed = Boolean(QuestionStore.getQuestion().dateClosed);

        const confirmationMessages = [
            {
                type: MessageType.MarkAsResolvedMessage,
                hide: !ResponseStore.hasNewMarkAsResolvedMessage() || questionIsClosed,
                show: ResponseStore.hasNewMarkAsResolvedMessage() && !questionIsClosed,
                buttons: [
                    {
                        label: i18n.t("rtm.text.end_chat"),
                        onClick: ActionBarHelper.acceptMarkAsResolved,
                    },
                    {
                        label: i18n.t("rtm.text.still_need_help"),
                        onClick: ActionBarHelper.rejectMarkAsResolved,
                    },
                ],
            },
            {
                type: MessageType.AutoResponseConfirmationMessage,
                hide: answerCount > 0 || questionIsClosed || !ResponseStore.hasPendingAutoResponse(),
                show: !questionIsClosed && ResponseStore.hasPendingAutoResponse(),
                buttons: [
                    {
                        label: window.companySettings.enableCustomAnswers
                            ? i18n.t("rtm.text.no_im_good")
                            : i18n.t("rtm.text.yes_im_good"),
                        onClick: ActionBarHelper.acceptAutoResponse,
                    },
                    {
                        label: window.companySettings.enableCustomAnswers
                            ? i18n.t("rtm.text.yes_still_need_help")
                            : i18n.t("rtm.text.still_need_help"),
                        onClick: ActionBarHelper.dismissAutoResponse,
                    },
                ],
            },
        ];

        if (find(confirmationMessages, { hide: true, type: messageType })) {
            this.onClearActionBar();
        }
        const messageToShow = find(confirmationMessages, message => message.show && messageType !== message.type);
        if (messageToShow) {
            this.setState({
                buttons: messageToShow.buttons,
                messageType: messageToShow.type,
            });
        }
    }

    static shouldDisplayMessage() {
        const { buttons, messageType } = this.getState();

        return buttons.length > 0 && !isEmpty(messageType);
    }

    static getMessageType() {
        return this.getState().messageType;
    }
}

export default alt.createStore(ConfirmationMessageStore, "ConfirmationMessageStore");
